module.exports = __webpack_public_path__ + "img/Pattern01.f96de325.png";